module.exports = __webpack_public_path__ + "img/aej1n-66wvl.019.c062e942.png";